/** Explorer Results view Evo */
import PolygonIcon from '@apps-common/ui-icons/Polygon.jsx';
import React from 'react';
import {SidePanel} from '@src/components/panels/SidePanels.tsx';

const AreasOfInterestPanel = React.lazy(
  () => import('@components/panels/aoi/AreasOfInterestPanel.jsx'),
);

const AreasOfInterest = () => {
  return (
    <SidePanel
      title="Areas of interest"
      headerProps={{icon: <PolygonIcon color="action" />}}
    >
      <AreasOfInterestPanel />
    </SidePanel>
  );
};

export default AreasOfInterest;
